import { helper } from '@ember/component/helper';

/**
 * Display-name resolver for a contact-shaped plain object (a flat API
 * payload row, NOT an Ember Data record — a real `contact` record already
 * exposes this exact logic via its `name` getter in
 * beebee-base-model/src/models/contact.js; use that getter directly when the
 * object is a record).
 *
 * Several list/dashboard endpoints (guide-segreteria "rifugi"/"prenotazioni"
 * /"attivita", noleggio dashboard, booking active_booking, communications
 * log) return a nested `{ ragione_sociale, last_name, first_name, ... }`
 * object instead of a hydrated contact record. Those templates used to
 * interpolate `last_name`/`first_name` directly, which prints a blank (or a
 * redundant doubled name) for a "persona giuridica" contact whose display
 * name lives in `ragione_sociale` (POP-167).
 *
 * `ragione_sociale` is only ever populated server-side for a legal
 * person/PA contact, so its presence alone is a safe signal — this mirrors
 * the model getter's outcome without requiring the `fisica_giuridica`/
 * `ente_pa` flags, which several of these flat payloads never include at
 * all (SQL query trimmed to the columns power each specific end point).
 *
 * NOTE: does not apply `model_custom_style.contact` (unlike `contact.name`)
 * since these payloads are not real contact records and are display-only.
 */
function contactName(c) {
  if (!c) return '';
  const ragioneSociale = typeof c.ragione_sociale === 'string' ? c.ragione_sociale.trim() : '';
  if (ragioneSociale) return ragioneSociale;
  const lastName = c.last_name ?? '';
  const firstName = c.first_name ?? '';
  return `${lastName} ${firstName}`.trim();
}
var contactName$1 = helper(([c]) => contactName(c));

export { contactName, contactName$1 as default };
//# sourceMappingURL=contact-name.js.map
